import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "./Icon";
/**
 * MoreIcon - A three-dot menu icon (ellipsis) used for more options menus
 */
export const MoreIcon = ({ size = 16, color = "#6B7280", orientation = "vertical", className = "", ...props }) => {
    if (orientation === "horizontal") {
        return (_jsxs(Icon, { size: size, color: color, viewBox: "0 0 16 16", className: className, ...props, children: [_jsx("circle", { cx: "3", cy: "8", r: "1.5", fill: color }), _jsx("circle", { cx: "8", cy: "8", r: "1.5", fill: color }), _jsx("circle", { cx: "13", cy: "8", r: "1.5", fill: color })] }));
    }
    // Vertical (default)
    return (_jsxs(Icon, { size: size, color: color, viewBox: "0 0 16 16", className: className, ...props, children: [_jsx("circle", { cx: "8", cy: "3", r: "1.5", fill: color }), _jsx("circle", { cx: "8", cy: "8", r: "1.5", fill: color }), _jsx("circle", { cx: "8", cy: "13", r: "1.5", fill: color })] }));
};
